import { HTTPError } from 'ky';

import { fastApi } from '@/services/api';

const PATH = 'v1/customer/form';

export enum AgreementKey {
  PROFESSIONAL_CLIENT_WAIVER = 'professional-client-waiver',
  SERVICES_AGREEMENT = 'services-agreement',
}

type SignedAgreementData = {
  date: string;
  name: string;
  signature: string;
};

type AgreementGetResponse = {
  date: string;
};

export type AgreementPostRequestBody = SignedAgreementData | undefined;

export const getAgreement = async (agreementKey: AgreementKey) => {
  return fastApi
    .get(`${PATH}/${agreementKey}`)
    .json<AgreementGetResponse>()
    .catch((error) => {
      if (error instanceof HTTPError && error.response.status === 404) return null;

      throw error;
    });
};

export const postAgreement = async (agreementKey: AgreementKey, body?: AgreementPostRequestBody) => {
  await fastApi.post(`${PATH}/${agreementKey}`, { json: body });
};
